module.exports = __webpack_public_path__ + "static/media/5.6812fed3.png";